import React from 'react';


const ExerciseDetail = (props) => {
    const {exerciseTime, breakTime} = props;

    return (
        <div>
            <h2 className="mt-5 text-lg ">Study details</h2>
            <div className="border-lime-500 border-2 mt-2 bg-lime-100 rounded-md p-4 grid grid-cols-1 md:grid-cols-2 gap-1">
                <h3 className="font-bold">Study time</h3>
                <h3>{exerciseTime} hours</h3>
            </div>
            <div className="border-lime-500 border-2 mt-2 bg-lime-100 rounded-md p-4 grid grid-cols-1 md:grid-cols-2 gap-1">
                <h3 className="font-bold">Break Time</h3>
                <h3>{breakTime} minutes</h3>
            </div>
        </div>
    );
};

export default ExerciseDetail;